import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { routing } from './help.routing';

// pages
import { ComplaintsComponent } from '../../../pages/complaints/complaints.component';
import { FraudPreventionPage } from '../../../pages/fraud-prevention/fraud-prevention.page';

// components
import { ComplaintFormComponent } from '../../../components/form/complaint-form/complaint-form.component';
import { CollectionsModule } from '../../../components/collections/collections.module';
// component modules
import { CommonComponentsModule } from '../../../modules/components/common/common.module';
import { CommonLoggedOutComponentsModule } from '../../../modules/components/common-logged-out/common-logged-out.module';
import { LoadingModule } from '../../../modules/components/loading/loading.module';
import { ValidationMessagesModule } from '../../../modules/components/validation-messages/validation-messages.module';

// services
import { CustomerHelpService } from '../../../services/customer-help.service';

@NgModule({
  declarations: [
    ComplaintsComponent,
    ComplaintFormComponent,
    FraudPreventionPage,
  ],
  imports: [
    routing,
    CommonModule,
    CommonComponentsModule,
    CommonLoggedOutComponentsModule,
    FormsModule,
    LoadingModule,
    ReactiveFormsModule,
    TextMaskModule,
    ValidationMessagesModule,
    CollectionsModule,
  ],
  providers: [CustomerHelpService],
})
export class HelpModule {}
